import * as React from 'react';
import { Panel, Row, Col } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { Clock } from './clock';
import SystemInfoApi from '../../api/SystemInfoApi';

class ErrorInternationalAtomicTimeIsInFuture extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            serverTime: Date.now()
        };
    }

    componentDidMount() {
        SystemInfoApi.getSystemDateTime().then((response: any) => {
            this.setState({
                serverTime: new Date(response)
            });
        });
    }

    render() {
        return (
            <div>
                <Panel className="error-clock center">
                    <Row className="analog-clocks-row">
                        <Col md={6}>
                            <div className="center">
                                {Translate('error/iat-is-in-the-future/current-time')}
                                :
                                <Clock startTime={new Date()} />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="center">
                                {Translate('error/iat-is-in-the-future/expected-time')}
                                :
                                <Clock startTime={this.state.serverTime} />
                            </div>
                        </Col>
                    </Row>
                    <Row className="analog-text-row">
                        <b>{Translate('error/iat-is-in-the-future/error-text/header')}!</b>
                        <br />
                        <br />
                        {Translate('error/iat-is-in-the-future/error-text/body')}
                        .
                        <br />
                    </Row>
                </Panel>
            </div>
        );
    }
}
export default ErrorInternationalAtomicTimeIsInFuture;
